import React, { useEffect } from "react";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import { connect } from "react-redux";
import Grid from '@mui/material/Grid';
import TabList from '@mui/lab/TabList';
import AccessCodeTable from "../components/AccessCodeTable";
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import { loadAccessCodeList } from "../api/accesscodeapi";
import LoaderComponent from "../components/LoaderComponent";
import { getAccessCodeList,  getAccessCodeLoading } from "../selector/selectors";
import { Link } from "react-router-dom";
import SearchBoxComponent from "../components/SearchBoxComponent";
import swal from 'sweetalert';

const ManageAccessCodeList = ({
  isLoading,
  accessCodeList,
  startLoadingAccessCodes,
}) => {

  const [page, setPage] = React.useState(0);
  const [value, setValue] = React.useState('1');
  const [rowsPerPage, setRowsPerPage]  = React.useState(10);
  const [searchValue, setSearchValue] = React.useState('');
  
  

  useEffect(() => {
    startLoadingAccessCodes();
  }, [startLoadingAccessCodes]);


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  const handleChangePage = (event, pageVal) => {
    setPage(pageVal);
    startLoadingAccessCodes(pageVal,rowsPerPage,searchValue);
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    startLoadingAccessCodes(0,event.target.value,searchValue);
  }


  const handleSearch = (event) => {
    setSearchValue(event.target.value);
    startLoadingAccessCodes(0,rowsPerPage,event.target.value);
  };

  const handleShare = (accessCode,userName) => {
    const body= `Username - ${userName} and Password - ${accessCode} `;
    const mailtoLink = `mailto:?&body=${body}`;
    window.location.href = mailtoLink
  }

  const handleCopy = (accessCode,userName) => {
    const body= `Username - ${userName} and Password - ${accessCode} `;
    navigator.clipboard.writeText(body);
    swal("Success", 'Copied successfully.', "success");
  }

  return (
    <Box sx={{ flexGrow: 1 }} >
      { isLoading ?  <LoaderComponent />: <></>}
      <Grid container >
        <TabContext value={value}>
          <Grid item xs={12} md={12} lg={12} >
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange} aria-label="">
                <Tab label="Passwords List" value="1" />
                <Link className="tabingLinks" to="/web/create-password">Request Passwords</Link>
              </TabList>
            </Box>
            <TabPanel value="1" sx={{p:0,pt:2}}>
              <Grid container sx={{paddingBottom:2, display: 'flex', justifyContent: 'space-between'}}>
                <Grid xs={5} sm={6} md={3}>
                  <SearchBoxComponent
                    handleChangeTextValue = {(e)=>handleSearch(e,'')}
                    label='Search Login / Email'
                  />   
                </Grid>
              </Grid>
              <AccessCodeTable 
                handleShare={handleShare}
                handleCopy={handleCopy} 
                accessCode={accessCodeList?.data} 
                page={page} 
                rowsPerPage={rowsPerPage} 
                handleChangeRowsPerPage={handleChangeRowsPerPage} 
                handleChangePage={handleChangePage} 
              />
            </TabPanel>
          </Grid>
        </TabContext>
      </Grid>
    </Box>
  );
}

const mapStateToProps = (state) => ({
  isLoading: getAccessCodeLoading(state),  
  accessCodeList:getAccessCodeList(state),  
});

const mapDispatchToProps = (dispatch) => ({
  startLoadingAccessCodes: (page,rowsPerPage,searchText) => dispatch(loadAccessCodeList(page,rowsPerPage,searchText)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageAccessCodeList);
